import { useContext } from 'react';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import { ViewerContext, NotFoundPage } from 'dash-ui';

/* TODO: perf: implement lazy loading */
import SignIn from 'pages/Authentication/SignInPage/SignInPage';
import SignUp from 'pages/Authentication/SignUpPage/SignUpPage';
import ForgotPasswordPage from 'pages/Authentication/ForgotPasswordPage/ForgotPasswordPage';
import ResetPasswordPage from 'pages/Authentication/ResetPasswordPage/ResetPasswordPage';
import PropertiesPage from 'pages/properties/PropertiesPage';
import PropertyPreviewPage from 'pages/properties/PropertyPreviewPage/PropertyPreviewPage';
import Dashboard from 'pages/Dashboard/Dashboard';

import { RoutesPath } from 'flow-components/routes/routes';
import AuthorizedRoute from 'flow-components/routes/AuthorizedRoute';
import UnauthorizedRoute from 'flow-components/routes/UnauthorizedRoute';

import useInitViewer from 'common/hooks/useInitViewer/useInitViewer';
import renderBranch from 'common/helpers/renderBranch';
import OrganizationPage from 'pages/OrganizationPage/OrganizationPage';
import PropertyDetailsPage from 'pages/properties/PropertyDetailsPage/PropertyDetailsPage';
import PropertyMediaFolderPage from 'pages/properties/PropertyMediaFolderPage/PropertyMediaFolderPage';
import ExternalSaleTeamsPage from 'pages/ExternalSaleTeamsPage/ExternalSaleTeamsPage';
import ExternalSalesUsersPage from 'pages/ExternalSalesUsersPage/ExternalSalesUsersPage';
import TermConditions from 'pages/flow/TermConditions/TermConditions';
import PrivacyPolicy from 'pages/flow/PrivacyPolicy/PrivacyPolicy';
import { usePortalLanguage } from 'shared/i18n';

function App() {
  const navigate = useNavigate();

  const [isViewerReady] = useInitViewer();
  usePortalLanguage();
  const { account } = useContext(ViewerContext);

  return renderBranch(
    isViewerReady,
    <Routes>
      <Route
        path={RoutesPath.Home}
        element={
          <AuthorizedRoute authorized={!!account} redirect={RoutesPath.SignIn}>
            <Navigate replace to={RoutesPath.Dashboard} />
          </AuthorizedRoute>
        }
      />
      <Route
        path={RoutesPath.SignIn}
        element={
          <UnauthorizedRoute authorized={!!account} redirect={RoutesPath.Home}>
            <SignIn />
          </UnauthorizedRoute>
        }
      />
      <Route
        path={RoutesPath.SignUp}
        element={
          <UnauthorizedRoute authorized={!!account} redirect={RoutesPath.Home}>
            <SignUp />
          </UnauthorizedRoute>
        }
      />
      <Route
        path={RoutesPath.ForgotPassword}
        element={<ForgotPasswordPage />}
      />
      <Route path={RoutesPath.ResetPassword} element={<ResetPasswordPage />} />

      <Route
        path={RoutesPath.PropertyPreview}
        element={
          <AuthorizedRoute authorized={!!account} redirect={RoutesPath.SignIn}>
            <PropertyPreviewPage />
          </AuthorizedRoute>
        }
      />
      <Route
        path={RoutesPath.PropertyDetails}
        element={
          <AuthorizedRoute authorized={!!account} redirect={RoutesPath.SignIn}>
            <PropertyDetailsPage />
          </AuthorizedRoute>
        }
      />
      <Route
        path={RoutesPath.PropertyMediaFolder}
        element={
          <AuthorizedRoute authorized={!!account} redirect={RoutesPath.SignIn}>
            <PropertyMediaFolderPage />
          </AuthorizedRoute>
        }
      />

      <Route
        path={RoutesPath.Dashboard}
        element={
          <AuthorizedRoute authorized={!!account} redirect={RoutesPath.SignIn}>
            <Dashboard />
          </AuthorizedRoute>
        }
      />
      <Route
        path={RoutesPath.Properties}
        element={
          <AuthorizedRoute authorized={!!account} redirect={RoutesPath.SignIn}>
            <PropertiesPage />
          </AuthorizedRoute>
        }
      />

      <Route
        path={RoutesPath.Organization}
        element={
          <AuthorizedRoute authorized={!!account} redirect={RoutesPath.SignIn}>
            <OrganizationPage />
          </AuthorizedRoute>
        }
      />

      <Route
        path={RoutesPath.ExternalSales}
        element={
          <AuthorizedRoute authorized={!!account} redirect={RoutesPath.SignIn}>
            <ExternalSaleTeamsPage />
          </AuthorizedRoute>
        }
      />

      <Route
        path={RoutesPath.ExternalSalesUsers}
        element={
          <AuthorizedRoute authorized={!!account} redirect={RoutesPath.SignIn}>
            <ExternalSalesUsersPage />
          </AuthorizedRoute>
        }
      />

      <Route path={RoutesPath.TermConditions} element={<TermConditions />} />
      <Route path={RoutesPath.PrivacyPolicy} element={<PrivacyPolicy />} />

      <Route
        path="*"
        element={<NotFoundPage onRedirect={() => navigate(RoutesPath.Home)} />}
      />
    </Routes>
  );
}

export default App;
